import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import "./signup.css";
import { getCountries, isSignUPAPI } from "../../../Helper/Redux/API";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const Registered = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [referralCode, setReferralCode] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const refer = params.get('refer');
    if (refer) {
      setReferralCode(refer);
    }
  }, []);
  
  console.log(referralCode)
  const initialValues = {
    firstName: "",
    lastName: "",
    password: "",
    confirmPassword: "",
    email: "",
    DateBirth: "",
    gender: "",
    Age: "",
    country_id: "",
    mob_number: "",
    home_number: "",
    address_one: "",
    address_two: "",
    postal_code: "",
    nric_number: "",
    race_number: "",
    role_id: "",
    Terms: false,
  };

  // const [refree_code , setRefreeCode]= useState{""};


  const [startDate, setStartDate] = useState(null);
  // Define the form submission function
  const onregister = (values, { resetForm }) => {
    // console.log("sdd");
    // Handle form submission logic here
    const data = {
      email: values.email,
      password: values.password,
      first_name: values.firstName,
      password_confirmation: values.confirmPassword,
      last_name: values.lastName,
      dob: values.DateBirth,
      gender: values.gender,
      age: values.Age,
      country_id: values.country_id,
      mob_number: values.mob_number,
      home_number: values.home_number,
      address_one: values.address_one,
      address_two: values.address_two,
      postal_code: values.postal_code,
      nric_number: values.nric_number,
      race_number: values.race_number,
      role_id: "2",
      refree_code:referralCode,
    };

    dispatch(isSignUPAPI(data)).then((res) => {
      if (res?.payload?.status == true) {
        let access_token = res?.payload?.access_token;
        let Username = res?.payload?.store_data?.first_name;
        let Userlast = res?.payload?.store_data?.last_name;
        let Userid = res?.payload?.store_data?.id;
        // let Roleid = res?.payload?.store_data?.roles[0].id;

        if (access_token != "" && access_token != "") {
          localStorage.setItem("access_token", access_token);
          localStorage.setItem("UserName", Username);
          localStorage.setItem("lastName", Userlast);
          localStorage.setItem("id", Userid);
          // localStorage.setItem("Roleid", Roleid);
          navigate("/Heartest");
          // toast.success(res.payload.message);
        }

        toast.success(res?.payload?.message);
      } else {
        toast.error(res?.payload?.message);

        // setTimeout(() => {
        //   props.setTabType("login");
        // }, [3000]);
      }
    });

    // console.log("Form submitted:", values);
    // resetForm();
  };
  const validation = Yup.object({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    DateBirth: Yup.string()
      .required("DOB is required")
      .test(
        "future-date",
        "Date of birth cannot be in the future",
        function (value) {
          // Parse the date string to a JavaScript Date object
          const selectedDate = new Date(value);
          // Get today's date
          const currentDate = new Date();
          // Compare selected date with today's date
          return selectedDate <= currentDate;
        }
      ),

    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string()
      .min(6, "Password should be at least 6 characters.")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm password is required"),

    gender: Yup.string().required("Gender is required"),
    // Age: Yup.number().required("Age is required"),
    Age: Yup.number()
      .min(1, "Age must be greater than 0")
      .required("Age is required"),
    country_id: Yup.string().required("Nationality is required"),
    mob_number: Yup.string().required("Mobile number is required"),
    // home_number: Yup.string("HOME Number is required"),
    address_one: Yup.string().required("Address line 1 is required"),
    // address_two: Yup.string().required("Address line 2 is required"),
    // postal_code: Yup.string().required("Postal Code is required"),
    // nric_number: Yup.string().required("NRIC Number is required"),
    // race_number: Yup.string().required("Race Number is required"),
    // role_id: Yup.string().required("Role is required"),
    Terms: Yup.boolean().test(
      "is-checked",
      "Please agree to the terms and conditions",
      (value) => value === true
    ),
  });

  const [allCountries, setAllCoountries] = useState("");
  const getcountriData = () => {
    dispatch(getCountries()).then((res) => {
      if (res?.payload?.status === true) {
        setAllCoountries(res?.payload?.data);
        // console.log(res?.payload?.data);
      } else {
        toast.error(res?.payload?.message);
      }
    });
  };

  const Countries = Array.isArray(allCountries)
    ? allCountries.map((item) => ({
        label: item.title,
        value: item.id,
      }))
    : [];

  // console.log("allCountries", Countries);

  useEffect(() => {
    getcountriData();
  }, []);
  const [showPassword, setShowPassword] = useState(false);
  const [today, setToday] = useState("");
  useEffect(() => {
    const todayDate = new Date().toISOString().split("T")[0];
    setToday(todayDate);
  }, []);
  return (
    <>
      <Header />
      <section className="log_form">
        <div className="container">
          <div className="row log_div">
            {/* <div className="bg_img_section"></div> */}
            <div className="col-lg-4 g-0">
              <div className="Fomr_text">
                <h2 className="wow  fadeInUp  animated">Welcome Back!</h2>
                <p className="wow  slideInLeft animated">
                  To keep connected with us please login with your personal Info
                </p>
                <Link to="/Login">
                  {" "}
                  <button className="btn wow  slideInUp animated">
                    Sign in
                  </button>
                </Link>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="form-container2">
                <h1 className="wow  zoomIn animated">Hello, Friends!</h1>
                <p className="wow  slideInLeft animated">
                  Enter your personal details and start journey with us
                </p>

                <Formik
                  initialValues={initialValues}
                  onSubmit={onregister}
                  validationSchema={validation}
                >
                  {(formik) => (
                    <Form>
                      <div className="input_container wow fadeInRight  animated">
                        {/* <div className="form_input">
                          <Field
                            as="select"
                            name="role_id"
                            className="form-select"
                            aria-label="role_id"
                          >
                            <option value="" disabled selected>
                              Role
                            </option>
                            <option value="2">User</option>
                            <option value="4">Hearing center</option>
                          </Field>

                          <ErrorMessage
                            name="role_id"
                            component="div"
                            className="text-danger"
                          />
                        </div> */}

                        <div className="form_input">
                          <Field
                            type="text"
                            name="firstName"
                            id="login_fname"
                            placeholder="Enter First Name*"
                          />
                          <ErrorMessage
                            name="firstName"
                            component="div"
                            className="text-danger"
                          />
                        </div>

                        <div className="form_input">
                          <Field
                            type="text"
                            name="lastName"
                            id="login_lname"
                            placeholder="Enter Last Name*"
                          />
                          <ErrorMessage
                            name="lastName"
                            component="div"
                            className="text-danger"
                          />
                        </div>

                        <div className="form_input">
                          <Field
                            type="date"
                            name="DateBirth"
                            id="Date_Birth"
                            onfocus="(this.type='date')"
                            onblur="(this.type='text')"
                            placeholder="Enter your birth date (DD/MM/YYYY)*"
                            pattern="\d{2}/\d{2}/\d{4}"
                            max={today}
                          />

                          {/* <DatePicker
                            selected={startDate}
                            name="DateBirth"
                            // id="Date_Birth"
                            onChange={(date) => setStartDate(date)}
                            placeholderText="Date Birth"
                            dateFormat="dd/MM/yyyy" // Set the date format
                            isClearable // Enable clearing the date
                            showYearDropdown // Show year dropdown
                            scrollableYearDropdown // Allow scrolling through years
                            yearDropdownItemNumber={15} // Number of years to show in the dropdown
                          /> */}

                          <ErrorMessage
                            name="DateBirth"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                        <div className="form_input">
                          <Field
                            type="email"
                            name="email"
                            id="login_email"
                            placeholder="Enter Your Email*"
                          />
                          <ErrorMessage
                            name="email"
                            component="div"
                            className="text-danger"
                          />
                        </div>

                        <div className="form_input">
                          {/* <h5 className="heading_login">Contact</h5> */}
                          <Field
                            type="number"
                            name="Age"
                            id="Age"
                            placeholder="Age*"
                          />
                          <ErrorMessage
                            name="Age"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                        <div className="form_input">
                          <Field
                            as="select"
                            name="gender"
                            className="form-select"
                            aria-label="gender"
                          >
                            <option value="" disabled selected>
                              Gender*
                            </option>
                            <option value="1">Male</option>
                            <option value="2">Female</option>
                            <option value="3">Other</option>
                          </Field>

                          <ErrorMessage
                            name="gender"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                        <div className="form_input">
                          <Field
                            as="select"
                            name="country_id"
                            className="form-select"
                            aria-label="country"
                          >
                            <option value="" disabled defaultValue>
                              Nationality
                            </option>
                            {Countries.map((country) => (
                              <option key={country.value} value={country.value}>
                                {country.label}
                              </option>
                            ))}
                          </Field>

                          <ErrorMessage
                            name="country_id"
                            component="div"
                            className="text-danger"
                          />
                        </div>

                        <div className="form_input">
                          <Field
                            type="number"
                            name="mob_number"
                            id="Mobile_Number"
                            placeholder="Mobile Number*"
                          />
                          <ErrorMessage
                            name="mob_number"
                            component="div"
                            className="text-danger"
                          />
                        </div>

                        <div className="form_input">
                          <Field
                            type="text"
                            name="home_number"
                            id="HomeNumber"
                            placeholder="Home Number"
                          />
                          {/* <ErrorMessage
                            name="home_number"
                            component="div"
                            className="text-danger"
                          /> */}
                        </div>
                        <div className="form_input password_hide">
                          <div className="password_hide">
                            <Field
                              type={showPassword ? "text" : "password"}
                              name="password"
                              id="login_password"
                              placeholder="Enter Your Password*"
                            />
                            <span
                              className="password-toggle-icon"
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              <FontAwesomeIcon
                                icon={showPassword ? faEyeSlash : faEye}
                              />
                            </span>
                          </div>

                          <ErrorMessage
                            name="password"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                        <div className="form_input">
                          <Field
                            type="password"
                            name="confirmPassword"
                            id="login_Cpassword"
                            placeholder="Enter Confirm Password*"
                          />
                          <ErrorMessage
                            name="confirmPassword"
                            component="div"
                            className="text-danger"
                          />
                        </div>

                        <div className="form_input">
                          {/* <h5 className="heading_login">Contact</h5> */}
                          <Field
                            type="text"
                            name="address_one"
                            id="Address_Line1"
                            placeholder="Address Line1*"
                          />
                          <ErrorMessage
                            name="address_one"
                            component="div"
                            className="text-danger"
                          />
                        </div>

                        <div className="form_input">
                          <Field
                            type="text"
                            name="address_two"
                            id="Address_Line2"
                            placeholder="Address Line2*"
                          />
                          {/* <ErrorMessage
                            name="address_two"
                            component="div"
                            className="text-danger"
                          /> */}
                        </div>

                        <div className="form_input">
                          <Field
                            type="number"
                            name="postal_code"
                            id="Postal_code"
                            placeholder="Postal Code"
                          />
                          {/* <ErrorMessage
                            name="postal_code"
                            component="div"
                            className="text-danger"
                          /> */}
                        </div>

                        <div className="form_input">
                          <Field
                            type="text"
                            name="nric_number"
                            id="NRIC_Number"
                            placeholder="NRIC Number"
                          />
                          {/* <ErrorMessage
                            name="nric_number"
                            component="div"
                            className="text-danger"
                          /> */}
                        </div>

                        {/* <div className="form_input">
                          <Field
                            type="text"
                            name="race_number"
                            id="Race Number"
                            placeholder="Race Number"
                          />
                          <ErrorMessage
                            name="race_number"
                            component="div"
                            className="text-danger"
                          />
                        </div> */}
                      </div>
                      <div className="form-check">
                        <Field
                          type="checkbox"
                          name="Terms"
                          id="termsAndConditions"
                          className="form-check-input"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="termsAndConditions"
                        >
                          I agree to the <span>Terms and Conditions</span>
                        </label>
                        <ErrorMessage
                          name="Terms"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                      <button
                        className="btn"
                        type="submit"
                        // disabled={!formik.isValid}
                      >
                        Submit
                      </button>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Registered;
